import { useTranslation } from 'react-i18next';

export default function PortfolioSection() {
  const { t } = useTranslation('common');

  const projects = [
    {
      key: 'local',
      image: 'https://public.readdy.ai/ai/img_res/75ee50f330f4c896869f9bb0f763f972.jpg'
    },
    {
      key: 'restaurant',
      image: 'https://readdy.ai/api/search-image?query=elegant%20restaurant%20website%20design%20showing%20menu%20layout%20food%20photography%20sections%20location%20map%20and%20contact%20form%20modern%20minimalist%20interface%20with%20warm%20inviting%20colors%20white%20background%20professional%20web%20design%20aesthetic&width=800&height=600&seq=portfolio2&orientation=landscape'
    },
    {
      key: 'beauty',
      image: 'https://readdy.ai/api/search-image?query=sophisticated%20beauty%20salon%20website%20design%20with%20elegant%20layout%20showing%20services%20gallery%20appointment%20booking%20section%20soft%20pastel%20colors%20white%20background%20modern%20minimalist%20professional%20web%20design%20aesthetic&width=800&height=600&seq=portfolio3&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('portfolio.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('portfolio.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) => (
            <div
              key={project.key}
              className="group bg-gray-50 rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={project.image}
                  alt={t(`portfolio.projects.${project.key}.title`)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {t(`portfolio.projects.${project.key}.title`)}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {t(`portfolio.projects.${project.key}.description`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}